// extracted by mini-css-extract-plugin
export default {"addButton":"patients_addButton__7AaKu","row":"patients_row__38Ihi","col":"patients_col__EsV4t","patientsTable":"patients_patientsTable__5Foa+"};